<template>
  <NotExist />
</template>

<script>
import NotExist from '@/components/common/PageNotExist.vue'

export default {
  name: 'PageNotExist',
  components: { NotExist }
}
</script>

<style scoped>

</style>
